import { useEffect } from "react";
import "./UpdateMelding.css";
import { RES_TYPES, useFetch } from "@chainless/chainless-react";

export const ApproveVerlof = ({ rowData, fetch, user }) => {
  const {
    res: putResRes,
    fetchData: putRes,
    error: putErr,
  } = useFetch(`/api/verlof/${rowData.id}`, {
    method: "PUT",
    resType: RES_TYPES.text,
    lateFetch: true,
  });

  // Helper om Date om te zetten naar timestamp (seconds)
  const dateToTimestamp = (date) =>
    date instanceof Date && !isNaN(date)
      ? Math.floor(date.getTime() / 1000)
      : null;

  useEffect(() => {
    if (putResRes && putResRes.ok) {
      fetch();
    } else if (putErr) {
      alert("Fout bij het versturen", putErr);
    }
  }, [putResRes, putErr, fetch]);

  const handleApprove = () => {
    if (window.confirm("Deze aanvraag goedkeuren?")) {
      putRes(
        JSON.stringify({
          ...rowData,
          omschrijving: rowData.omschrijving,
          uren: rowData.uren,
          start: dateToTimestamp(rowData.start),
          eind: dateToTimestamp(rowData.eind),
          statusAanvraag: "GOEDGEKEURD",
          datumGoedgekeurd: Math.floor(Date.now() / 1000),
          goedgekeurdDoor: user,
        })
      );
    }
  };

  const handleReject = () => {
    if (window.confirm("Deze aanvraag afwijzen?")) {
      putRes(
        JSON.stringify({
          ...rowData,
          omschrijving: rowData.omschrijving,
          uren: rowData.uren,
          start: dateToTimestamp(rowData.start),
          eind: dateToTimestamp(rowData.eind),
          statusAanvraag: "AFGEWEZEN",
          datumGoedgekeurd: Math.floor(Date.now() / 1000),
          goedgekeurdDoor: user,
        })
      );
    }
  };

  return (
    <>
      {rowData.statusAanvraag === "IN_BEHANDELING" && (
        <div className="verlof-goedkeuren-row">
          <button onClick={handleApprove} className="update-melding-save-btn">
            Goedkeuren
          </button>
          <button
            onClick={handleReject}
            className="update-melding-save-btn"
            style={{ marginLeft: 8 }}
          >
            Afwijzen
          </button>
        </div>
      )}
    </>
  );
};
